export const DEVELOPMENT = ({ ...props }) => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="8" fill="#51C275" fillOpacity="0.05" />
      <rect
        x="0.666477"
        y="0.666477"
        width="54.667"
        height="54.667"
        rx="7.33352"
        stroke="#51C275"
        strokeOpacity="0.15"
        strokeWidth="1.33295"
      />
      <path
        d="M26.569 35.3159L30.319 21.5659M33.6523 24.8993L35.3731 26.7275C36.2791 27.6901 36.2791 29.1917 35.373 30.1543L33.6523 31.9826M23.2357 31.9826L21.515 30.1543C20.609 29.1917 20.609 27.6901 21.515 26.7275L23.2357 24.8993"
        stroke="#51C275"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
